<ng-select
  ngSelectExtension
  class="new-select new-select-multiple project-stages-select w-100"
  [formControl]="filter"
  [items]="stages"
  bindLabel="name"
  bindValue="id"
  [placeholder]="'ProjectsTimeline.projectsFilter' | translate"
  [clearable]="true"
  [multiple]="true"
  [closeOnSelect]="false"
  [searchable]="false"
>
  <ng-template ng-option-tmp let-item="item" let-item$="item$">
    <svg-icon *ngIf="item$.selected" src="/assets/img/check-checked-icon.svg"></svg-icon>
    <div *ngIf="!item$.selected" class="not-selected"></div>
    <span>{{ item.name }}</span>
  </ng-template>
  <ng-template ng-multi-label-tmp>
    <div class="selected-items text-capitalize">
      <ng-container *ngIf="selectedTypes.length === 1">
        <span *ngFor="let selectedStage of selectedTypes" class="selected-item">
          {{ 'Projects.Stage.' + selectedStage | translate }}
        </span>
      </ng-container>
      <span class="selected-number" *ngIf="selectedTypes.length > 1">
        {{ 'Global.selected' | translate: { count: selectedTypes.length } }}
      </span>
    </div>
  </ng-template>
</ng-select>
